import { usePermissions } from './use-permissions';

/**
 * Hook that returns whether the current user has admin privileges.
 * Backed by usePermissions, which reads Cognito group membership or the
 * `custom:isAdmin` claim from the ID token payload.
 *
 * Requirements: 1.9, 5.1, 5.2
 */
export function useIsAdmin(): { isAdmin: boolean; isLoading: boolean } {
  const { isAdmin, isLoading } = usePermissions();
  return { isAdmin, isLoading };
}
